const tocNode = document.querySelector('div.gh-toc')
if(tocNode) {
  tocbot.init ({
    tocSelector: '.toc',
    contentSelector: '.gh-content',
    ignoreSelector: '.js-toc-ignore, .gh-post-upgrade-cta h2',
    headingSelector: 'h1, h2, h3',
    hasInnerContainers: true,
  });
}